import { _ } from "libs";

import React from "react";
import Avatar from "../../avatar";
import PlayerItemMedium from "../player/medium";
import { Championship, ChampionshipLeague } from "../../../types";
import { getLeagueInfo } from "../player/playerHelper";
import cx from "classnames";

const MatchItemMedium = ({
	result,
	name,
	meta,
	photoUrl,
	isBuddy,
	coach,
	points,
	gender = "",
	className = "",
	leagueId,
	championship,
}: {
	result: Boolean;
	name: string;
	meta: any; //string | Element;
	photoUrl: string;
	leagueId?: string;
	championship?: Championship;
	isBuddy?: boolean;
	coach?: string;
	points?: number;
	gender?: string;
	className?: string;
}) => {
	// const league: ChampionshipLeague | null = getLeagueInfo(championship, leagueId);
	return (
		<div className={cx("item", "match", "medium", className)} data-result={result ? "victory" : "defeat"}>
			<div className="resultLabel">{ result ? _("match.victory") : _("match.defeat") }</div>
			<PlayerItemMedium
				name={name}
				meta={meta}
				photoUrl={photoUrl}
				leagueId={leagueId}
				championship={championship}
			/>
		</div>
	);
};

export default MatchItemMedium;
